import { AddCircle, Close, Save } from "@mui/icons-material"
import { LoadingButton } from "@mui/lab";
import { Autocomplete, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormGroup, Grid, InputAdornment, MenuItem, Select, TextField } from "@mui/material";
import ArgonBox from "components/ArgonBox";
import ArgonButton from "components/ArgonButton"
import ArgonInput from "components/ArgonInput";
import ArgonTypography from "components/ArgonTypography";
import { getDataWithResponse } from "global/getFunc";
import { postSubmit } from "global/postFunc";
import { useEffect, useState } from "react";
import TambahKelompok from "./TambahKelompok";
import { postDataWithResponse } from "global/postFunc";

const bulan = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const bulanPanjang = [
    'januari',
    'februari',
    'maret',
    'april',
    'mey',
    'juni',
    'juli',
    'agustus',
    'september',
    'oktober',
    'november',
    'desember'
];

const TambahRincian = ({ parentData, decryptedUser, updating, setUpdating, addReq, ...props }) => {

    const [loading, setLoading] = useState(false)
    const [saving, setSaving] = useState(false)
    const [updatingKm, setUpdatingKm] = useState(false)

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [listRekeningAkun, setListRekeningAkun] = useState([])
    const [rekeningAkun, setRekenigAkun] = useState({})
    const [metodePengadaan, setMetodePengadaan] = useState('')
    const [penerimaManfaat, setPenerimaManfaat] = useState('')
    const [listSumberPendanaan, setListSumberPendanaan] = useState([])
    const [sumberDana, setSumberaDana] = useState({})
    const [komponen, setKomponen] = useState('')
    const [listKelPaket, setListKelPaket] = useState([])
    const [selectedKelPaket, setSelectedKelPaket] = useState({})
    const [spesifikasi, setSpesifikasi] = useState('')
    const [satuan, setSatuan] = useState('')
    const [volume, setVolume] = useState('')
    const [anggaran, setAnggaran] = useState('')
    const [projekStrategis, setProjekStrategis] = useState(false)
    const [target, setTarget] = useState({
        januari: '',
        februari: '',
        maret: '',
        april: '',
        mey: '',
        juni: '',
        juli: '',
        agustus: '',
        september: '',
        oktober: '',
        november: '',
        desember: ''
    })
    const [targetFisik, setTargetFisik] = useState({
        januari: '',
        februari: '',
        maret: '',
        april: '',
        mey: '',
        juni: '',
        juli: '',
        agustus: '',
        september: '',
        oktober: '',
        november: '',
        desember: ''
    })

    // useEffect(() => { console.log(projekStrategis); }, [projekStrategis])

    useEffect(() => {
        if (open) {
            setRekenigAkun({})
            setSumberaDana({})
            setKomponen('')
            setSelectedKelPaket({})
            setSpesifikasi('')
            setSatuan('')
            setVolume('')
            setAnggaran('')
            setProjekStrategis(false)
            console.log(parentData);
            reqRekeningAkun();
            reqSumberPendanaan();
            setMetodePengadaan('')
            setPenerimaManfaat('')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    // useEffect(() => {
    //     console.log(rekeningAkun);
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [rekeningAkun])

    // useEffect(() => {
    //     console.log(selectedKelPaket);
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [selectedKelPaket])

    useEffect(() => {
        if (metodePengadaan === 'Swakelola') {
            setPenerimaManfaat('On Site')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [metodePengadaan])

    useEffect(() => {
        // setSelectedKelPaket({})
        rekeningAkun.kode && reqKelompokPaket()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rekeningAkun, updatingKm])

    const reqKelompokPaket = () => {
        setLoading(true)
        addReq()
        postDataWithResponse(
            '/admin-opd/kelompok-paket/filter',
            {
                ta: parentData.ta,
                kd_pd: parentData.kd_pd,
                kd_subkegiatan: parentData.kode,
                kode_rekening_akun: rekeningAkun.kode,
            },
            decryptedUser,
            (res) => {
                setLoading(false)
                setListKelPaket(res)
            },
            (res) => {
                setLoading(false)
                setOpen(false)
            }
        );
    }

    const reqRekeningAkun = () => {
        setListRekeningAkun([])
        setLoading(true)
        addReq()
        getDataWithResponse(
            '/kodefikasi-rekening-belanja',
            decryptedUser,
            (res) => {
                setLoading(false)
                setListRekeningAkun(res)
            },
            (res) => {
                setLoading(false)
                setOpen(false)
            }
        );
    }

    const reqSumberPendanaan = () => {
        setListSumberPendanaan([])
        setLoading(true)
        addReq()
        getDataWithResponse(
            // '/get-subrincianobjek-belanja-by-rincianobjek/' + params,
            '/sumber-pendanaan',
            decryptedUser,
            (res) => {
                setLoading(false)
                setListSumberPendanaan(res)
            },
            (res) => {
                setLoading(false)
                setOpen(false)
            }
        );
    }

    const submit = (e) => {
        e.preventDefault();
        let formData = {
            // id_sub_rincian_objek: `${parentData.id}-${subRincianObjekBl.kd_sub_rincian_objek}`,
            ta: parentData.ta,
            kd_pd: parentData.kd_pd,
            kd_subkegiatan: parentData.kode,
            id_subkegiatan: parentData.ta + "-" + parentData.kd_pd + "-" +parentData.kode,
            kode_rekening_akun: rekeningAkun.kode,
            uraian_rekening_akun: rekeningAkun.uraian,
            kel_paket_id: selectedKelPaket.id,
            kel_paket_uraian: selectedKelPaket.uraian,
            kode_sumber_dana: sumberDana.kode,
            uraian_sumber_dana: sumberDana.uraian,
            nama_komponen: komponen,
            spesifikasi: spesifikasi,
            satuan: satuan,
            volume: volume,
            anggaran: anggaran.replace(/,(?=\d{3})/g, ''),
            metode_pengadaan: metodePengadaan,
            projek_strategis: projekStrategis,
            status_pelaksanaan: 'Belum Terlaksana',
            target: target
        };
        // console.log(formData);
        setSaving(true)
        postSubmit(
            '/admin-opd/komponen-belanja/tambah',
            formData,
            decryptedUser,
            (res) => {
                setSaving(false)
                setOpen(false)
                setUpdating(!updating)
            },
            (res) => {
                setSaving(false)
                // setOpen(false)
            }
        )
        console.log('submit');
    }

    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
    const handleAnggaranChange = (event) => {
        setAnggaran(addCommas(removeNonNumeric(event.target.value)))
    }

    const [openPengelompokan, setOpenPengelompokan] = useState(false);

    const handleClickOpenPengelompokan = () => {
        setOpenPengelompokan(true);
    };

    const handleClosePengelompokan = () => {
        setOpenPengelompokan(false);
    };

    const targetChange = (e) => {
        setTarget({ ...target, [e.target.name]: addCommas(removeNonNumeric(e.target.value)) })
    }
    
    const targetFisikChange = (e) => {
        setTargetFisik({ ...targetFisik, [e.target.name]: e.target.value })
    }

    // useEffect(() => {
    //     console.log(target);
    //     console.log(targetFisik);

    // }, [target, targetFisik])

    return (
        <>
            <ArgonButton
                variant='contained'
                color="primary"
                size="small"
                startIcon={<AddCircle />}
                onClick={handleOpen}
                {...props}
            >
                Tambah
            </ArgonButton>
            <Dialog
                open={open}
                maxWidth="md"
                fullWidth
                // fullScreen
                scroll='paper'
                p={3}
                component='form'
                onSubmit={submit}
            >
                <DialogTitle>
                    <ArgonTypography variant='body2' fontWeight="bold">Tambah Komponen Belanja</ArgonTypography>
                </DialogTitle>
                <DialogContent p={3}>
                    <ArgonBox mb={1}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Sub Kegiatan : {parentData.kd_subkegiatan} {parentData.nama_subkegiatan}
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Rekening Akun
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonBox mb={1}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={listRekeningAkun}
                                fullWidth
                                required
                                getOptionLabel={(option) => option.kode + ' ' + option.uraian}
                                onChange={(event, newValue) => {
                                    newValue !== null && setRekenigAkun(newValue)
                                }}
                                onInputChange={(event, newInputValue) => {
                                    newInputValue === "" && setRekenigAkun({})
                                    // newInputValue.length > 7 && reqDpt()
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        InputProps={{
                                            ...params.InputProps,
                                            required: true,
                                            endAdornment: (
                                                <>
                                                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                            />
                        </ArgonBox>
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Uraian Pengelompokan Belanja / Paket Pekerjaan
                            </ArgonTypography>
                        </ArgonBox>
                        <FormControl fullWidth>
                            {/* <InputLabel id="demo-simple-select-standard-label">Age</InputLabel> */}
                            <Select
                                placeholder="Select year"
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectedKelPaket.id || ''}
                                onChange={(e) => {
                                    let result = listKelPaket.find(item => item.id === e.target.value)
                                    setSelectedKelPaket(result)
                                }}
                                required
                                endAdornment={
                                    loading && <CircularProgress color="inherit" size={20} />
                                }
                            >
                                <MenuItem key='9999' value='' disabled><em>Pilih </em></MenuItem>
                                {
                                    listKelPaket.map((kelPaket, index) => (
                                        <MenuItem key={index} value={kelPaket.id}>{kelPaket.uraian}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                        <Button size="small" color="primary" disabled={!rekeningAkun.kode} onClick={handleClickOpenPengelompokan} variant="text">Tambah Pengelompokan Belanja / Paket Pekerjaan</Button>
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Sumber Pendanaan
                            </ArgonTypography>
                        </ArgonBox>
                        <Autocomplete
                            id="combo-box-demo"
                            options={listSumberPendanaan}
                            fullWidth
                            required
                            getOptionLabel={(option) => option.kode + ' ' + option.uraian}
                            onChange={(event, newValue) => {
                                newValue !== null && setSumberaDana(newValue)
                            }}
                            onInputChange={(event, newInputValue) => {
                                newInputValue === "" && setSumberaDana({})
                                // newInputValue.length > 7 && reqDpt()
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputProps={{
                                        ...params.InputProps,
                                        required: true,
                                        endAdornment: (
                                            <>
                                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />
                            )}
                        />
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Komponen
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            required
                            size="medium"
                            value={komponen}
                            onChange={(e) => { setKomponen(e.target.value) }}
                            autoComplete='off'
                        />
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Spesifikasi
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            required
                            size="medium"
                            value={spesifikasi}
                            onChange={(e) => { setSpesifikasi(e.target.value) }}
                            autoComplete='off'
                        />
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <Grid container spacing={2}>
                            <Grid item lg={6}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Volume
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="number"
                                    required
                                    size="medium"
                                    value={volume}
                                    onChange={(e) => { setVolume(e.target.value) }}
                                    autoComplete='off'
                                />
                            </Grid>
                            <Grid item lg={6}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Satuan
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="text"
                                    required
                                    size="medium"
                                    value={satuan}
                                    onChange={(e) => setSatuan(e.target.value)}
                                    autoComplete='off'
                                />
                            </Grid>
                        </Grid>
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Anggaran
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            required
                            size="medium"
                            value={anggaran}
                            onChange={handleAnggaranChange}
                            autoComplete='off'
                            startAdornment={
                                <InputAdornment position="start">
                                    <ArgonTypography component="label" variant="caption" >
                                        Rp
                                    </ArgonTypography>
                                </InputAdornment>
                            }
                        />
                    </ArgonBox>
                    <ArgonBox mt={2} mb={1}>
                        <FormGroup>
                            <FormControlLabel control={<Checkbox onChange={(e) => setProjekStrategis(!projekStrategis)} />} label={
                                <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                    Projek Strategis
                                </ArgonTypography>
                            } />
                        </FormGroup>
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Mekanisme Pelaksanaan
                            </ArgonTypography>
                        </ArgonBox>
                        <FormControl fullWidth>
                            <Select
                                value={metodePengadaan || ''}
                                onChange={(e) => {
                                    setMetodePengadaan(e.target.value)
                                }}
                                required
                            >
                                <MenuItem key={1} value='Penyedia'>Penyedia</MenuItem>
                                <MenuItem key={2} value='Swakelola'>Swakelola</MenuItem>
                            </Select>
                        </FormControl>
                    </ArgonBox>
                    {
                        metodePengadaan === 'Swakelola' &&
                        <ArgonBox mb={1}>
                            <ArgonBox mb={1} ml={0.5}>
                                <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                    Penerima Manfaat
                                </ArgonTypography>
                            </ArgonBox>
                            <ArgonInput
                                type="text"
                                required
                                size="medium"
                                value={penerimaManfaat}
                                autoComplete='off'
                                disabled
                            />
                        </ArgonBox>
                    }
                    {/* <ArgonBox mb={1}>
                        <ArgonBox ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Target Realisasi Keuangan
                            </ArgonTypography>
                        </ArgonBox>
                        <Grid container spacing={2}>
                            <Grid item xs={12} lg={6}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            Januari
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="januari"
                                        value={target.januari}
                                        onChange={targetChange}
                                        autoComplete='off'
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <ArgonTypography component="label" variant="caption" >
                                                    Rp
                                                </ArgonTypography>
                                            </InputAdornment>
                                        }
                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            Februari
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="februari"
                                        value={target.februari}
                                        onChange={targetChange}
                                        autoComplete='off'
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <ArgonTypography component="label" variant="caption" >
                                                    Rp
                                                </ArgonTypography>
                                            </InputAdornment>
                                        }
                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ pt: '0 !important' }}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            Maret
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="maret"
                                        value={target.maret}
                                        onChange={targetChange}
                                        autoComplete='off'
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <ArgonTypography component="label" variant="caption" >
                                                    Rp
                                                </ArgonTypography>
                                            </InputAdornment>
                                        }
                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ pt: '0 !important' }}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            April
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="april"
                                        value={target.april}
                                        onChange={targetChange}
                                        autoComplete='off'
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <ArgonTypography component="label" variant="caption" >
                                                    Rp
                                                </ArgonTypography>
                                            </InputAdornment>
                                        }
                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ pt: '0 !important' }}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            Mey
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="mey"
                                        value={target.mey}
                                        onChange={targetChange}
                                        autoComplete='off'
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <ArgonTypography component="label" variant="caption" >
                                                    Rp
                                                </ArgonTypography>
                                            </InputAdornment>
                                        }
                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ pt: '0 !important' }}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            Juni
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="juni"
                                        value={target.juni}
                                        onChange={targetChange}
                                        autoComplete='off'
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <ArgonTypography component="label" variant="caption" >
                                                    Rp
                                                </ArgonTypography>
                                            </InputAdornment>
                                        }
                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ pt: '0 !important' }}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            Juli
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="juli"
                                        value={target.juli}
                                        onChange={targetChange}
                                        autoComplete='off'
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <ArgonTypography component="label" variant="caption" >
                                                    Rp
                                                </ArgonTypography>
                                            </InputAdornment>
                                        }
                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ pt: '0 !important' }}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            Agustus
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="agustus"
                                        value={target.agustus}
                                        onChange={targetChange}
                                        autoComplete='off'
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <ArgonTypography component="label" variant="caption" >
                                                    Rp
                                                </ArgonTypography>
                                            </InputAdornment>
                                        }
                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ pt: '0 !important' }}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            September
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="september"
                                        value={target.september}
                                        onChange={targetChange}
                                        autoComplete='off'
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <ArgonTypography component="label" variant="caption" >
                                                    Rp
                                                </ArgonTypography>
                                            </InputAdornment>
                                        }
                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ pt: '0 !important' }}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            Oktober
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="oktober"
                                        value={target.oktober}
                                        onChange={targetChange}
                                        autoComplete='off'
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <ArgonTypography component="label" variant="caption" >
                                                    Rp
                                                </ArgonTypography>
                                            </InputAdornment>
                                        }
                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ pt: '0 !important' }}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            November
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="november"
                                        value={target.november}
                                        onChange={targetChange}
                                        autoComplete='off'
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <ArgonTypography component="label" variant="caption" >
                                                    Rp
                                                </ArgonTypography>
                                            </InputAdornment>
                                        }
                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ pt: '0 !important' }}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            Desember
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="desember"
                                        value={target.desember}
                                        onChange={targetChange}
                                        autoComplete='off'
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <ArgonTypography component="label" variant="caption" >
                                                    Rp
                                                </ArgonTypography>
                                            </InputAdornment>
                                        }
                                    />
                                </ArgonBox>
                            </Grid>
                        </Grid>
                    </ArgonBox> */}
                    {/* <ArgonBox mb={1}>
                        <ArgonBox ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Target Realisasi Fisik
                            </ArgonTypography>
                        </ArgonBox>
                        <Grid container spacing={2}>
                            <Grid item xs={12} lg={6}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            Januari
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="januari"
                                        defaultValue={targetFisik.januari}
                                        onChange={targetFisikChange}
                                        autoComplete='off'
                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            Februari
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="februari"
                                        defaultValue={targetFisik.februari}
                                        onChange={targetFisikChange}
                                        autoComplete='off'

                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ pt: '0 !important' }}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            Maret
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="maret"
                                        defaultValue={targetFisik.maret}
                                        onChange={targetFisikChange}
                                        autoComplete='off'

                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ pt: '0 !important' }}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            April
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="april"
                                        defaultValue={targetFisik.april}
                                        onChange={targetFisikChange}
                                        autoComplete='off'

                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ pt: '0 !important' }}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            Mey
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="mey"
                                        defaultValue={targetFisik.mey}
                                        onChange={targetFisikChange}
                                        autoComplete='off'

                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ pt: '0 !important' }}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            Juni
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="juni"
                                        defaultValue={targetFisik.juni}
                                        onChange={targetFisikChange}
                                        autoComplete='off'

                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ pt: '0 !important' }}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            Juli
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="juli"
                                        defaultValue={targetFisik.juli}
                                        onChange={targetFisikChange}
                                        autoComplete='off'

                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ pt: '0 !important' }}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            Agustus
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="agustus"
                                        defaultValue={targetFisik.agustus}
                                        onChange={targetFisikChange}
                                        autoComplete='off'

                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ pt: '0 !important' }}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            September
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="september"
                                        defaultValue={targetFisik.september}
                                        onChange={targetFisikChange}
                                        autoComplete='off'

                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ pt: '0 !important' }}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            Oktober
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="oktober"
                                        defaultValue={targetFisik.oktober}
                                        onChange={targetFisikChange}
                                        autoComplete='off'

                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ pt: '0 !important' }}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            November
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="november"
                                        defaultValue={targetFisik.november}
                                        onChange={targetFisikChange}
                                        autoComplete='off'

                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ pt: '0 !important' }}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            Desember
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <ArgonInput
                                        type="text"
                                        // required
                                        size="medium"
                                        name="desember"
                                        defaultValue={targetFisik.desember}
                                        onChange={targetFisikChange}
                                        autoComplete='off'

                                    />
                                </ArgonBox>
                            </Grid>
                        </Grid>
                    </ArgonBox> */}
                </DialogContent>
                <DialogActions>
                    <Grid container spacing={2} justifyContent='flex-end' px={2} mb={2}>
                        <Grid item>
                            <ArgonButton
                                color='info'
                                variant='outlined'
                                size="small"
                                startIcon={<Close />}
                                onClick={handleClose}
                                disabled={saving}
                            >
                                Batal
                            </ArgonButton>
                        </Grid>
                        <Grid item>
                            <LoadingButton
                                color='info'
                                variant='contained'
                                size="small"
                                startIcon={<Save />}
                                type='submit'
                                loading={saving}
                            >
                                Simpan
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>

            <TambahKelompok
                open={openPengelompokan}
                handleClose={handleClosePengelompokan}
                // metodePengadaan={metodePengadaan}
                parentData={rekeningAkun}
                decryptedUser={decryptedUser}
                ta={parentData.ta}
                kd_pd={parentData.kd_pd}
                kd_subkegiatan={parentData.kode}
                updating={updatingKm}
                setUpdating={setUpdatingKm}
            />
        </>
    )
}

export default TambahRincian